import React, { useState } from 'react'
import styles from './presetApply.jcss'
import EditText from '../../../blocks.simple/editText/editText'
import translate from '../../../core/translate'
import Button from '../../../blocks.simple/button/button'
import Dropdown from '../../../blocks.simple/dropdown/dropdown'
import { cn } from 'ethcss'
import { api } from '../../../core/api/ConnectionManager'
import Checkbox from '../../../blocks.simple/checkbox/checkbox'

export const PresetApply = ({ selectedItems, onClose }: any) => {
    const [preset, setPreset] = useState({
        enabled: true,
        name: 'NetUp',
        vlcViewType: 'surface',
        vlcSettingString:
            '--audio-time-stretch --avcodec-skiploopfilter 1 --avcodec-skip-frame 0 --avcodec-skip-idct 0 --subsdec-encoding   --stats --audio-resampler soxr --freetype-rel-fontsize=16 --freetype-color=16777215 --freetype-opacity=255 --freetype-background-opacity=0 --freetype-shadow-color=0 --freetype-shadow-opacity=128 --freetype-outline-thickness=4 --freetype-outline-color=0 --freetype-outline-opacity=255 --keystore file_crypt none -vvv --no-sout-chromecast-audio-passthrough --sout-chromecast-conversion-quality=2 --sout-keep --smb-force-v1 --preferred-resolution=-1 --repeat --network-caching=1000',
        useExoIfCan: false,
    })

    const presetValues = [
        { title: translate('NetUp'), id: 'NetUp' },
        { title: translate('Ugoos 01'), id: 'Ugoos01' },
        { title: translate('Ugoos 02'), id: 'Ugoos02' },
        { title: translate('manualSettings'), id: 'manualSettings' },
    ]
    const vlcViewTypeValues = [
        { title: translate('vlc_layout'), id: 'vlc_layout' },
        { title: translate('surface'), id: 'surface' },
        { title: translate('texture'), id: 'texture' },
    ]
    const onChangePreset = (key: string, value: string | boolean) => {
        setPreset({
            ...preset,
            [key]: value,
        })
    }

    const onSave = () => {
        api.send('iptvSetPreset', { preset, id: selectedItems })

        onClose()
    }

    return (
        <div className={styles.presetApply}>
            <div className={styles.inner}>
                <div className={cn(styles.field, styles.twinField)}>
                    <Dropdown
                        mod={'default'}
                        options={presetValues}
                        valueField={'id'}
                        labelField={'title'}
                        label={translate('preset')}
                        value={preset.name}
                        onChange={(value: any) => onChangePreset('name', value.id)}
                    />
                </div>
                {preset.name === 'manualSettings' && (
                    <>
                        <div className={styles.field}>
                            <Dropdown
                                mod={'default'}
                                options={vlcViewTypeValues}
                                valueField={'id'}
                                labelField={'title'}
                                label={translate('vlcViewType')}
                                value={preset.vlcViewType}
                                onChange={(value: any) => {
                                    onChangePreset('vlcViewType', value.id)
                                }}
                            />
                        </div>
                        <div className={styles.field}>
                            <EditText
                                value={preset.vlcSettingString}
                                onChange={(value: string) => {
                                    onChangePreset('vlcSettingString', value)
                                }}
                                containerClass={styles.separator}
                                className={cn(styles.input)}
                                label={translate('VLCSettings')}
                            />
                        </div>
                        <div className={cn(styles.field, styles.twinField)}>
                            <Checkbox
                                labelClassName={styles.label}
                                wrapperClassName={!preset.enabled ? styles.inputDisabled : ''}
                                disabled={!preset.enabled}
                                label={translate('exoAsPriority')}
                                checked={preset.useExoIfCan}
                                onClick={() => {
                                    onChangePreset('useExoIfCan', !preset.useExoIfCan)
                                }}
                            />
                        </div>
                    </>
                )}
                <div className={styles.controls}>
                    <Button mod={'withBorder'} className={styles.button} onClick={onClose}>
                        {translate('cancel')}
                    </Button>
                    <Button mod="fill" className={styles.button} onClick={onSave}>
                        {translate('apply')}
                    </Button>
                </div>
            </div>
        </div>
    )
}
